<template>
  <a-layout class="dict-content">
    <div class="searchDiv">
      <a-button type="primary" @click="add" v-if="$auth('fieldManage.addOredit')">新增</a-button>
      <div class="queryConditionDiv">
        <a-input v-model="searchModel.name" class="marginRight_12 searchColInput" placeholder="字段名称"></a-input>
        <a-input v-model="searchModel.id" class="marginRight_12 searchColInput" placeholder="字段ID"></a-input>
        <a-select
          v-model="searchModel.status"
          allowClear
          class="marginRight_12 searchColInput"
          placeholder="字段状态"
        >
          <a-select-option v-for="(item, index) in fieldTypeList" :key="index" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-input v-model="searchModel.remark" class="marginRight_12 searchColInput" placeholder="备注"></a-input>
        <a-button class="marginRight_12" type="primary" @click="search()">查询</a-button>
        <a-button @click="reset()">重置</a-button>
      </div>
    </div>
    <a-table
      :columns="tableData.columns"
      :data-source="tableData.data"
      :pagination="tableData.pagination"
      :rowKey="record => record.id"
      :scroll="{ y: tableHeight }"
      class="listTable"
      @change="handleTableChange">
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:" @click="() => handleView(record)">
          查看
        </a>
        <a href="javascript:" @click="() => handleEdit(record)" v-if="$auth('fieldManage.addOredit')">
          <a-divider type="vertical" />
          编辑
        </a>
        <a v-if="record.status === 1 && $auth('fieldManage.disabled')" href="javascript:" @click="() => forBiddenCheck(record)">
          <a-divider type="vertical" />
          禁用
        </a>
        <a-popconfirm v-if="record.status === 2 && $auth('fieldManage.startUse')" title="确认启用该字段吗？" @confirm="() => startUse(record)">
          <a href="javascript:">
            <a-divider type="vertical" />
            启用
          </a>
        </a-popconfirm>
        <a href="javascript:" @click="() => onDeleteCheck(record)" style="color: red;" v-if="$auth('fieldManage.del')">
          <a-divider type="vertical" />
          删除
        </a>
      </template>
    </a-table>
    <!--    新增/编辑弹窗-->
    <editModules ref="editModules" @getTableData="getTableData"></editModules>
    <!--    详情弹窗-->
    <viewModules ref="viewModules"></viewModules>
  </a-layout>
</template>

<script>
import editModules from '@/views/fieldManage/modules/editModules.vue'
import viewModules from '@/views/fieldManage/modules/viewModules.vue'
import TagSelectOption from '@/components/TagSelect/TagSelectOption'
import { delField, delFieldCheck, forbidden, forbiddenCheck, getTableData, startUsing } from '@/api/fieldManage'

export default {
  name: 'FieldManage',
  components: {
    TagSelectOption,
    editModules,
    viewModules
  },
  data () {
    return {
      // 搜索条件
      searchModel: {
        name: '',
        id: '',
        status: undefined,
        remark: ''
      },
      // 字段状态
      fieldTypeList: [
        {
          id: 1,
          name: '启用'
        },
        {
          id: 2,
          name: '禁用'
        }
      ],
      // 表格
      tableData: {
        columns: [
          {
            title: '字段名称',
            dataIndex: 'name'
          },
          {
            title: '字段ID',
            dataIndex: 'id'
            // width: 100
          },
          {
            title: '字段简称',
            dataIndex: 'nameDesc'
            // width: 200
          },
          {
            title: '字段状态',
            dataIndex: 'status',
            customRender: (text, record) => {
              return record.status === 1 ? '在用' : '禁用'
            }
            // width: 100
          },
          {
            title: '字段类型',
            dataIndex: 'valueType',
            customRender: (text, record) => {
              return record.valueType === 1 ? '填空' : record.valueType === 2 ? '单选' : '日期'
            }
            // width: 100
          },
          {
            title: '单选要求',
            dataIndex: 'valueOptions'
          },
          {
            title: '字段长度限制',
            customRender: (text, record) => {
              const lengthMax = record.lengthMax ? String(record.lengthMax) : ''
              if (lengthMax) {
                return 0 + '-' + lengthMax
              } else {
                return ''
              }
            }
            // width: 100
          },
          {
            title: '备注',
            dataIndex: 'remark'
          },
          {
            title: '操作',
            width: 200,
            scopedSlots: {
              customRender: 'actions'
            }
          }
        ],
        data: [],
        pagination: {
          pageNum: 1,
          pageSize: 20,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '40'],
          showSizeChanger: true,
          showQuickJumper: true
        }
      },
      tableHeight: 'calc(100vh - 223px)'
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    // 获取表格数据
    getTableData () {
      const params = {
        name: this.searchModel.name,
        id: this.searchModel.id,
        status: this.searchModel.status ? this.searchModel.status : '',
        remark: this.searchModel.remark,
        ...this.tableData.pagination
      }
      getTableData(params).then(res => {
        if (res.status === 0) {
          this.tableData.data = res.data.list
          this.tableData.pagination.total = res.data.total
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 切换页码
    handleTableChange (pagination) {
      this.tableData.pagination.pageNum = pagination.current
      this.tableData.pagination.pageSize = pagination.pageSize
      this.getTableData()
    },
    // 搜索
    search () {
      this.getTableData()
    },
    // 重置
    reset () {
      this.searchModel = {
        name: '',
        id: '',
        status: undefined,
        remark: ''
      }
      this.getTableData()
    },
    // 新增
    add () {
      this.$refs.editModules.setTitle('新建字段')
      this.$refs.editModules.setType('add')
      this.$refs.editModules.open(true)
    },
    // 编辑
    handleEdit (record) {
      this.$refs.editModules.setTitle('编辑字段')
      this.$refs.editModules.setType('edit')
      this.$refs.editModules.setModel(record)
      this.$refs.editModules.open(true)
    },
    // 查看详情
    handleView (record) {
      this.$refs.viewModules.setModel(record)
      this.$refs.viewModules.open(true)
    },
    // 启用
    startUse (record) {
      startUsing({ ids: record.id }).then(res => {
        if (res.status === 0) {
          this.$message.success('启用成功')
          this.getTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 禁用校验
    forBiddenCheck (record) {
      const data = {
        id: record.id
      }
      const that = this
      forbiddenCheck(data).then(res => {
        if (res.status === 0) {
          if (res.data.state === 'SUCCESS') {
            that.tip(res.data.msg, 'forBidden', data)
          } else {
            that.$message.error(res.data.msg)
          }
        } else {
          that.$message.error(res.info.message)
        }
      })
        .catch(err => {
          that.$message.error(err.info.message)
        })
    },
    // 禁用
    forBidden (data) {
      const that = this
      forbidden(data).then(res => {
        if (res.status === 0) {
          that.$message.success('禁用成功')
          that.getTableData()
        } else {
          that.$message.error(res.info.message)
        }
      })
        .catch(err => {
          that.$message.error(err.info.message)
        })
    },
    // 删除
    onDeleteCheck (record) {
      const data = {
        id: record.id
      }
      delFieldCheck(data).then(res => {
        if (res.status === 0) {
          if (res.data.state === 'SUCCESS') {
            this.tip(res.data.msg, 'del', { ids: record.id })
          } else {
            this.$message.error(res.data.msg)
          }
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 删除
    delField(data) {
      delField(data).then(res => {
        if (res.status === 0) {
          this.$message.success('删除成功')
          this.getTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 提示
    tip (title, type, data) {
      const that = this
      that.$confirm({
        title: (h) => {
          return h('div', {
            domProps: {
              innerHTML: title
            }
          })
        },
        onOk () {
          if (type === 'forBidden') {
            that.forBidden(data)
          } else {
            that.delField(data)
          }
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dict-content {
  overflow-y: hidden;
  background-color: #ffffff;
  padding: 20px;
}
.searchDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .searchColInput {
    width: 200px;
  }
}
.marginRight_12 {
  margin-right: 12px;
}

/deep/.listTable  {
  height: calc(100% - 50px);
  >.ant-spin-nested-loading {
    height: 100%;
    >.ant-spin-container {
      height: calc(100% - 50px);
      .ant-table {
        height: 100%;
        .ant-table-content {
          height: 100%;
          .ant-table-scroll{
            height: 100%;
            .ant-table-body {
              height: calc(100% - 40px);
            }
          }
        }
      }
      .ant-table-placeholder {
        position: absolute;
        background: none;
        border-top: none;
        border-bottom: none;
        border-radius: 0 0 4px 4px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        height: 100px;
        .ant-empty-normal {
          margin: 0 !important;
        }
      }
    }
  }
}
/deep/.ant-form-item {
  display: flex;
}
</style>
